// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__BqrAx","content":"styles_content__YViHd","checkbox":"styles_checkbox__1h_Em","checkboxLabel":"styles_checkboxLabel__2B8Sw"};